import React, { Component } from 'react';
import './App.css';


class Programming extends Component {
  render() { 
    var list = this.props.programming.split(":");
    const listItems = list.map((item) =>
	  <li key={item}>{item}</li>
	);
    return (
	<ul>
	{listItems}
	</ul>
	);
  }
}

class Tools extends Component {
  render() { 
    var list = this.props.tools.split(":");
    const listItems = list.map((item) =>
	  <li key={item}>{item}</li>
	);
    return (
	<ul>
	{listItems}
	</ul>
	);
  }
}
class OS extends Component {
  render() { 
    var list = this.props.os.split(":");
    const listItems = list.map((item) =>
	  <li key={item}>{item}</li>
	);
    return (
	<ul>
	{listItems}
	</ul>
	);
  }
}
class Frameworks extends Component {
  render() { 
    var list = this.props.frameworks.split(":");
    const listItems = list.map((item) =>
	  <li key={item}>{item}</li>
	);
    return (
	<ul>
	{listItems}
	</ul>
	);
  }
}
class Technologies extends Component {
  render() { 
    var list = this.props.tech.split(":");
    const listItems = list.map((item) =>
	  <li key={item}>{item}</li>
	);
    return (
	<ul>
	{listItems}
	</ul>
	);
  }
}

// Main block that will show the overall job block
	  //<Skills {...this.props} />
// eslint-disable-next-line
class SkillOutline extends Component {
  render() { 
    return (
	<div className="SkillOutline">
	<b>Skills:</b>
	  <li>Programing</li>
	  <Programming {...this.props} />


	  <li>Operating Systems</li>
	  <OS {...this.props} />

	  <li>Tools</li>
	  <Tools {...this.props} />

	  <li>Frameworks/Libraries</li>
	  <Frameworks {...this.props} />
	  <li>Technologies</li>
	  <Technologies {...this.props} />

	      
	</div>
	);
  }
}
export class SkillOutline__ extends Component {
  render() { 
    return (
	<div className="SkillOutline">
	Skills
	 {this.props.children}
	</div>
	);
  }
}
// One skill.
// name
// profencany
export class SkillItem extends Component {
  render() { 
    const divStyle = {
      'background-color': 'green',
      'width': this.props.prof,
    }

    return (
	<div className="SkillItem">
          <div style={{"width":"50px"}}>
	    {this.props.name}
	  </div>
	  <div style={divStyle}>
	    {this.props.prof}
	  </div>
	</div>
	);
  }
}

/*
	<ol>
	  <li>Programing</li>
	  <Programming {...this.props} />

	  <li>Tools</li>
	  <Tools {...this.props} />

	  <li>Operating Systems</li>
	  <OS {...this.props} />

	  <li>Frameworks/Libraries</li>
	  <Frameworks {...this.props} />
	  <li>Technologies</li>
	  <Technologies {...this.props} />

	  </ol>
	  */
export default SkillOutline;



// WEBPACK FOOTER //
// ./src/SkillOutline.js